import React, { Component } from 'react';
import {Button, Header,Modal, Dropdown} from 'semantic-ui-react';
import '../../assets/css/home.css';
import ExploreTheWorld from './ExploreTheWorld';
import WhyChooseLMT from './WhyChooseLMT';
import FeaturedTours from './FeaturedTours.js';
import TravelStories from './TravelStories.js';
import Testimonials from './Testimonials.js';
import logo_lmt from '../../assets/images/lmt-logo.png';
import dividerRight from '../../assets/images/divider-right.png';
import dividerLeft from '../../assets/images/divider-left.png';
import headerBorder from '../../assets/images/line-orange.png';

import {Redirect} from 'react-router';

const tourOptions = [
	{
	  key: 'tourBalkan',
	  text: 'Eastern of Europe and The Balkans',
	  value: 0,
	  route: '/tours/TourBalkan'

	},
	{
	  key: 'tourNZ',
	  text: 'New Zealand',
	  value: 1,
	  route: '/tours/TourNZ'
	},
	{
	  key: 'tourHolyLand',
	  text: 'Holy Land and Pilgrimage',
	  value: 2,
	  route: '/tours/TourHolyLand'
	},
	{
	  key: 'tourIcelandSummer',
	  text: 'Iceland - Summer Edition',
	  value: 3,
	  route: '/tours/TourIcelandSummer'
	},
	{
	  key: 'tourIcelandWinter',
	  text: 'Iceland - Aurora Winter Edition',
	  value: 4,
	  route: '/tours/TourIcelandWinter'
	},
	{
	  key: 'tourCANY',
	  text: 'Eastern Canada and New York',
	  value: 5,
	  route: '/tours/TourCANY'
	},
	{
	  key: 'tourAfrica',
	  text: 'South Africa',
	  value: 6,
	  route: '/tours/TourAfrica'
	},
	{
	  key: 'tourBaltic',
	  text: 'The Highlights of Baltic',
	  value: 7,
	  route: '/tours/TourBaltic'
	},
	{
	  key: 'tourLatinAmerica',
	  text: 'Best of Latin America',
	  value: 8,
	  route: '/tours/TourLatinAmerica'
	},
	{
	  key: 'tourCaminoDeSantiago',
	  text: 'Spain:Camino de Santiago',
	  value: 9,
	  route: '/tours/TourCaminoDeSantiago'
	},
	{
	  key: 'tourCanadianRockies',
	  text: 'The Canadian Rockies',
	  value: 10,
	  route: '/tours/TourCanadianRockies'
	},
	{
	  key: 'tourWinterNorway',
	  text: 'Winter in Norway and Northern Lights',
	  value: 11,
	  route: '/tours/TourWinterNorway'
	},
	{
	  key: 'tourTurkey',
	  text: 'Turkey (Seven Churches of Revelations)',
	  value: 12,
	  route: '/tours/TourWinterTurkey'
	},
	{
	  key: 'tourRwandaAndUganda',
	  text: 'Rwanda and Uganda',
	  value: 13,
	  route: '/tours/TourRwandaAndUganda'
	},
	{
	  key: 'tourWinterTurkey',
	  text: 'Turkey',
	  value: 14,
	  route: '/tours/TourWinterTurkey'
	}
]

class Home extends Component {
	constructor(props){
		super(props);
		this.state = { 
			modalOpen: !sessionStorage.getItem('openModal'),
			redirect: false
		}
	}
	

	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	handleClose = () => {
		this.setState({ 
			modalOpen: false
		});
		sessionStorage.setItem('openModal', false)
	}
	
	handleRedirect = () => {
		this.setState({
			redirect: true,
		});
	}

	onChange = (e, {value}) => {
		this.setState({ 
			route: 	value === 0 ? '/tours/TourBalkan' : 
					value === 1 ? '/tours/TourNZ' : 
					value === 2 ? '/tours/TourHolyLand' : 
					value === 3 ? '/tours/TourIcelandSummer' : 
					value === 4 ? '/tours/TourIcelandWinter' : 
					value === 5 ? '/tours/TourCANY' :
					value === 6 ? '/tours/TourAfrica': 
					value === 7 ? '/tours/TourBaltic':
					value === 8 ? '/tours/TourLatinAmerica':
					value === 9 ? '/tours/TourCaminoDeSantiago':
					value === 10 ? '/tours/TourCanadianRockies':
					value === 11 ? '/tours/TourWinterNorway':
					value === 12 ? '/tours/TourWinterTurkey':
					value === 13 ? '/tours/TourRwandaAndUganda':
					value === 14 ? '/tours/TourWinterTurkey':
					''
		})
	}
	
  render() {
    return (
		<div>	
			{ this.state.redirect &&
				<Redirect push to={this.state.route}/>
			}
			<div className="page-section" >
				
				<ExploreTheWorld/>

				<div className="section-content-wrapper">
					<WhyChooseLMT/>
				</div>

				<div className="divider-wrapper-right">
					<img src={dividerRight} className="divider-right" alt="Plane divider" />
				</div>

				<div className="section-content-wrapper align-center">
					<h1 className="section-header align-center">Explore the world</h1>
					<img src={headerBorder} className="header-border align-center" alt="" />
					<p className="para-content">Carefully designed for all types of travelers, this unique selection of organized tours is an incredible way to see the best of the world.</p>
			
					<FeaturedTours/>
				</div>

				<div className="divider-wrapper-left ">
					<img src={dividerLeft} className="divider-left" alt="Plane divider" />
				</div>

				<div className="margin-bottom-5">
					<div className="section-content-wrapper ">
						<Testimonials/>
					</div>
				</div>
				
				<div className="divider-wrapper-right">
					<img src={dividerRight} className="divider-right" alt="Plane divider" />
				</div>

				

				<div className="travel-stories-wrapper ">
					<div className="section-content-wrapper">
						<TravelStories/>
					</div>
				</div>
			</div>
			
			
			<Modal open={this.state.modalOpen} onClose={this.handleClose} basic size='small' closeIcon dimmer='blurring' closeOnDimmerClick={false}> 
				<Header content='' />
				<Modal.Content>
					<img src={logo_lmt} className="logo-lmt" alt="Light Miles Travel" />
					<h2>Everyone wants to be taken somewhere. Where do you plan to go?</h2>
					<Dropdown placeholder='Select tour' fluid selection options={tourOptions} onChange ={this.onChange}
					/>
				</Modal.Content>
				<Modal.Actions>
					<Button color='orange' onClick={this.handleClose} inverted>Go to Home</Button>
					<Button color='orange' onClick={this.handleRedirect}>Fly in</Button>
				</Modal.Actions>
			</Modal>
		</div>

    );
  }
}

export default Home;